/**
 * PDP hover zoom — the CSS scales the gallery image on hover; this
 * moves the transform origin under the cursor so the zoom inspects the
 * spot the shopper is pointing at, the way a magnifier would.
 * Hover-capable devices only; touch keeps the plain gallery.
 */
if (matchMedia('(hover: hover)').matches) {
  document.addEventListener(
    'pointermove',
    (e) => {
      const container = e.target.closest?.('.product-media-container');
      if (!container) return;
      const img = container.querySelector('img');
      if (!img) return;
      const rect = container.getBoundingClientRect();
      const ox = ((e.clientX - rect.left) / rect.width) * 100;
      const oy = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = `${ox.toFixed(1)}% ${oy.toFixed(1)}%`;
    },
    { passive: true }
  );
}
